module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAALVBMVEUAAADM1t3M1t3M1t3M1t3M1t3M1t3M1t2ImaaImaaImaaImaaImaaImabM1t2JMdPHAAAAD3RSTlMAYN//jwAQn3Df/+8QYFD0Qq7OAAAAmElEQVR4Ae3WMQ3CAABE0aIFCYeV4xgAE+eiEiqhEqqOhEBYSPkDMPXPT8Afft9ur4MfDX7fsZI+oQigAhQBVIAigApQBFABigAqQBFABSgCqABFAHUNnab5ntbQOAO0AHSev4W8oQ1t6P9oIWgk6DIB9KwEhSCXoBDkEhSCXIJCkEtQCHIJCkEuQSHIJSgEuQRdwa69ougGQaQ+ebn9c+kAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f508.png
// module id = 1083
// module chunks = 0